<template>
  <div>
    <div align="left" dir="ltr" style="margin-left: -5.4pt">
      <table style="border: none; border-collapse: collapse">
        <tbody>
          <tr style="height: 26.3pt">
            <td
              style="
                border-left: solid #000000 0.5pt;
                border-right: solid #000000 0.5pt;
                border-bottom: solid #000000 0.5pt;
                border-top: solid #000000 0.5pt;
                vertical-align: top;
                padding: 0pt 5.4pt 0pt 5.4pt;
                overflow: hidden;
                overflow-wrap: break-word;
              "
            >
              <p
                dir="ltr"
                style="
                  line-height: 1.2;
                  text-align: center;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                "
              >
                <span
                  style="
                    font-size: 18pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Agreement Articles</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 26.3pt">
            <td
              style="
                border-left: solid #000000 0.5pt;
                border-right: solid #000000 0.5pt;
                border-bottom: solid #000000 0.5pt;
                border-top: solid #000000 0.5pt;
                vertical-align: top;
                padding: 0pt 5.4pt 0pt 5.4pt;
                overflow: hidden;
                overflow-wrap: break-word;
              "
            >
              <br />
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article I - Acknowledgement of Federal Funding from Greene
                  County Missouri</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must acknowledge their use of federal
                  funding when issuing statements, press releases, requests for
                  proposals, bid invitations, and other documents describing
                  projects or programs funded in whole or in part with Federal
                  funds.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article II - Age Discrimination Act of 1975</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with the requirements of the
                  Age Discrimination Act of 1975 (42 U.S.C. &sect; 6101 et
                  seq.), which prohibits discrimination on the basis of age in
                  any program or activity receiving Federal financial
                  assistance.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article III - Americans with Disabilities Act of 1990</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with the requirements of Titles
                  I, II, and III of the Americans with Disabilities Act, which
                  prohibits recipients from discriminating on the basis of
                  disability in the operation of public entities, public and
                  private transportation systems, places of public
                  accommodation, and certain testing entities (42 U.S.C.
                  &sect;&sect; 12101&ndash;12213).</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article IV - Best Practices for Collection and Use of
                  Personally Identifiable Information (PII)</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients who collect PII are required to have a
                  publically available privacy policy that describes what PII
                  they collect, how they use the PII, whether they share PII
                  with third parties, and how individuals may have their PII
                  corrected where appropriate. Personally identifiable
                  information (PII) is defined as any information that permits
                  the identity of an individual to be directly or indirectly
                  inferred, including any information that is linked or linkable
                  to that individual.&nbsp;</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article V- Civil Rights Act of 1964</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with the requirements of Title
                  VI of the Civil Rights Act of 1964 (42 U.S.C. &sect;&sect;
                  2000d et seq.), which provides that no person in the United
                  States will, on the grounds of race, color, or national
                  origin, be excluded from participation in, be denied benefits
                  of, or be subjected to discrimination under any program or
                  activity receiving Federal financial assistance. Implementing
                  regulations for the Act are found at 6 C.F.R. Part 21 and 44
                  C.F.R. Part 7.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article VI - Civil Rights Act of 1968</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with Title VIII of the Civil
                  Rights Act of 1968, which prohibits subrecipients from
                  discriminating in the sale, rental, financing, and advertising
                  of dwellings, or in the provision of services in connection
                  therewith, on the basis of race, color, national origin,
                  religion, disability, familial status, and sex (42 U.S.C.
                  &sect; 3601 et seq.), as implemented by the Department of
                  Housing and Urban Development at 24 C.F.R. Part 100. The
                  prohibition on disability discrimination includes the
                  requirement that new multifamily housing with four or more
                  dwelling units&mdash;i.e., the public and common use areas and
                  individual apartment units (all units in buildings with
                  elevators and ground-floor units in buildings without
                  elevators)&mdash;be designed and constructed with certain
                  accessible features (see 24 C.F.R. &sect; 100.201).</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article VII &ndash; Copyright</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must affix the applicable copyright notices
                  of 17 U.S.C. Sections 401 or 402 and an acknowledgement of
                  Government sponsorship (including award number) to any work
                  first produced under Federal financial assistance
                  awards.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article VIII - Assurances, Administrative Requirements, Cost
                  Principles, and Audit Requirements</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Certain assurances in this document may not be applicable to
                  your program, and the awarding agency may require applicants
                  to certify additional assurances. Please contact the program
                  awarding office if you have any questions. The administrative
                  and audit requirements and cost principles that apply to
                  Greene County Commission award subrecipients originate from 2
                  C.F.R. Part 200, Uniform Administrative Requirements, Cost
                  Principles, and Audit Requirements for Federal Awards.</span
                >
              </p>
              <br />
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article IX - Debarment and Suspension</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Subrecipients are subject to the non-procurement debarment
                  and suspension regulations implementing Executive Orders
                  (E.O.) 12549 and 12689, and 2 C.F.R. Part 180. These
                  regulations restrict federal financial assistance awards,
                  subawards, and contracts with certain parties that are
                  debarred, suspended, or otherwise excluded from or ineligible
                  for participation in federal assistance programs or
                  activities.&nbsp;</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article X - Drug-Free Workplace Regulations</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with drug-free workplace
                  requirements in Subpart B (or Subpart C, if the Subrecipient
                  is an individual) of 2 C.F.R. part 3001, which adopts the
                  Government-wide implementation (2 C.F.R. part 182) of sec.
                  5152-5158 of the Drug-Free Workplace Act of 1988 (Pub. L.
                  100-690, Title V, Subtitle D; 41 U.S.C. 8101).&nbsp;</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XI - Duplication of Benefits</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Any cost allocable to a particular Federal award provided for
                  in 2 C.F.R. Part 200, Subpart E may not be charged to other
                  Federal awards to overcome fund deficiencies, to avoid
                  restrictions imposed by Federal statutes, regulations, or
                  terms and conditions of the Federal awards, or for other
                  reasons. However, this prohibition would not preclude the
                  non-Federal entity from shifting costs that are allowable
                  under two or more Federal awards in accordance with existing
                  Federal statutes, regulations, or the terms and conditions of
                  the Federal awards.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XII - Energy Policy and Conservation Act</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with the requirements of 42
                  U.S.C. &sect; 6201 which contain policies relating to energy
                  efficiency that are defined in the state energy conservation
                  plan issues in compliance with this Act.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XIII - False Claims Act and Program Fraud Civil
                  Remedies</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with the requirements of 31
                  U.S.C. &sect; 3729 which set forth that no recipient of
                  federal payments shall submit a false claim for payment. See
                  also 38 U.S.C. &sect; 3801-3812 which details the
                  administrative remedies for false claims and statements
                  made.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XIV &ndash; Federal Debt Status</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients are required to be non-delinquent in their
                  repayment of Federal debt. Examples of relevant debt include
                  delinquent payroll and other taxes, audit disallowances, and
                  benefit overpayments. See OMB Circular A-129 and form SF-428B,
                  item number 17 for additional information and
                  guidance.&nbsp;</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XV - Hotel and Motel Fire Safety Act of 1990</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >In accordance with Section 6 of the Hotel and Motel Fire
                  Safety Act of 1990, 15 U.S.C. &sect;2225a, all subrecipients
                  must ensure that all conference, meeting, convention, or
                  training space funded in whole or in part with Federal funds
                  complies with the fire prevention and control guidelines of
                  the Federal Fire Prevention and Control Act of 1974, as
                  amended, 15 U.S.C. &sect;2225.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XVI - Limited English Proficiency (Civil Rights Act
                  of 1964, Title VI)</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with the Title VI of the Civil
                  Rights Act of 1964 (Title VI) prohibition against
                  discrimination on the basis of national origin, which requires
                  that recipients of federal financial assistance take
                  reasonable steps to provide meaningful access to persons with
                  limited English proficiency (LEP) to their programs and
                  services.&nbsp;</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XVII - Lobbying Prohibitions</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with 31 U.S.C. &sect;1352,
                  which provides that none of the funds provided under an award
                  may be expended by the recipient to pay any person to
                  influence, or attempt to influence an officer or employee of
                  any agency, a Member of Congress, an officer or employee of
                  Congress, or an employee of a Member of Congress in connection
                  with any Federal action related to a federal award or
                  contract, including any extension, continuation, renewal,
                  amendment, or modification.</span
                >
              </p>
              <br />
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XVIII - Non-supplanting Requirement</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients who receive awards made under programs that
                  prohibit supplanting by law must ensure that Federal funds do
                  not replace (supplant) funds that have been budgeted for the
                  same purpose through non-Federal sources.&nbsp;</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XIX - Patents and Intellectual Property Rights</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Unless otherwise provided by law, subrecipients are subject
                  to the Bayh-Dole Act, Pub. L. No. 96-517, as amended, and
                  codified in 35 U.S.C. &sect; 200 et seq. All recipients are
                  subject to the specific requirements governing the
                  development, reporting, and disposition of rights to
                  inventions and patents resulting from financial assistance
                  awards are in 37 C.F.R. Part 401 and the standard patent
                  rights clause in 37 C.F.R. &sect; 401.14.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XX - Procurement of Recovered Materials</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with section 6002 of the Solid
                  Waste Disposal Act, as amended by the Resource Conservation
                  and Recovery Act. The requirements of Section 6002 include
                  procuring only items designated in guidelines of the
                  Environmental Protection Agency (EPA) at 40 C.F.R. Part 247
                  that contain the highest percentage of recovered materials
                  practicable, consistent with maintaining a satisfactory level
                  of competition.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXI - Contract Provisions for Non-federal Entity
                  Contracts under Federal Awards</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >In addition to other provisions required by the Federal
                  agency or non-Federal entity, all contracts made by the
                  non-Federal entity under the Federal award must contain
                  provisions covering the following, as applicable.</span
                >
              </p>
              <ol
                style="
                  margin-top: 0;
                  margin-bottom: 0;
                  padding-inline-start: 48px;
                "
              >
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      text-align: justify;
                      margin-top: 0pt;
                      margin-bottom: 0pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Contracts for more than the simplified acquisition
                      threshold currently set at $150,000, which is the
                      inflation adjusted amount determined by the Civilian
                      Agency Acquisition Council and the Defense Acquisition
                      Regulations Council (Councils) as authorized by 41 U.S.C.
                      1908, must address administrative, contractual, or legal
                      remedies in instances where contractors violate or breach
                      contract terms, and provide for such sanctions and
                      penalties as appropriate.</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      text-align: justify;
                      margin-top: 0pt;
                      margin-bottom: 0pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >All contracts in excess of $10,000 must address
                      termination for cause and for convenience by the
                      non-Federal entity including the manner by which it will
                      be effected and the basis for settlement.&nbsp;</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      margin-top: 0pt;
                      margin-bottom: 0pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Equal Employment Opportunity. Except as otherwise
                      provided under 41 CFR Part 60, all contracts that meet the
                      definition of &ldquo;</span
                    ><span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: underline;
                        -webkit-text-decoration-skip: none;
                        text-decoration-skip-ink: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >federally assisted construction contract</span
                    ><span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >&rdquo; in 41 CFR Part 60-1.3 must include the equal
                      opportunity clause provided under 41 CFR 60-1.4(b), in
                      accordance with Executive Order 11246, &ldquo;Equal
                      Employment Opportunity&rdquo; (30 FR 12319, 12935, 3 CFR
                      Part, 1964-1965 Comp., p. 339), as amended by Executive
                      Order 11375, &ldquo;Amending Executive Order 11246
                      Relating to Equal Employment Opportunity,&rdquo; and
                      implementing regulations at 41 CFR part 60, &ldquo;Office
                      of Federal Contract Compliance Programs, Equal Employment
                      Opportunity, Department of Labor.&rdquo;</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      margin-top: 0pt;
                      margin-bottom: 10pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Davis-Bacon Act, as amended (40 U.S.C 3141-3148). When
                      required by Federal program legislation, all&nbsp;</span
                    ><span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: underline;
                        -webkit-text-decoration-skip: none;
                        text-decoration-skip-ink: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >prime construction contracts</span
                    ><span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >&nbsp;in excess of $2,000 awarded by non-Federal entities
                      must include a provision for compliance with the
                      Davis-Bacon Act (40 U.S.C. 3141-3144, and 3146-3148) as
                      supplemented by Department of Labor regulations (29 CFR
                      Part 5, &ldquo;Labor Standards Provisions Applicable to
                      Contracts Covering Federal Financed and Assisted
                      Construction&rdquo;). In accordance with the statute,
                      contracts must be required to pay wages to laborers and
                      mechanics at a rate not less than the prevailing wages
                      specified in a wage determination made by the Secretary of
                      Labor. In addition, contractors must be required to pay
                      wages not less than once a week. The non-Federal entity
                      must place a copy of the current prevailing wage
                      determination issued by the Department of Labor in each
                      solicitation. The decision to award a contract or
                      subcontract must be conditioned upon the acceptance of
                      wage determination. The non-Federal entity must report all
                      suspected or reported violations to the Federal awarding
                      agency. The contracts must also include a provision for
                      compliance with the Copeland &ldquo;Anti-Kickback&rdquo;
                      Act (40 U.S.C. 3145), as supplemented by Department of
                      Labor regulations (29 CFR Part 3, &ldquo;Contractors and
                      Subcontractors on Public Building or Public Work Financed
                      in Whole or in Part by Loans or Grants from the United
                      States&rdquo;). The Act provides that each contractor or
                      subrecipient must be prohibited from inducing, by any
                      means, any person employed in the construction,
                      completion, or repair of public work, to give up any part
                      of the compensation to which he or she is otherwise
                      entitled. The non-Federal entity must report all suspected
                      or reported violations to the Federal awarding
                      agency.&nbsp;</span
                    >
                  </p>
                </li>
              </ol>
              <br /><br /><br />
              <ol
                start="5"
                style="
                  margin-top: 0;
                  margin-bottom: 0;
                  padding-inline-start: 48px;
                "
              >
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      margin-top: 0pt;
                      margin-bottom: 0pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Contract Work Hours and Safety Standards Act (40 U.S.C.
                      3701-3708). Where applicable, all contracts awarded by the
                      non-Federal entity in excess of $100,000 that involve the
                      employment of mechanics or laborers must include a
                      provision for compliance with 40 U.S.C 3704 and 3704, as
                      supplemented by Department of Labor regulations (29 CFR
                      Part 5). Under 40 U.S.C. 3702 of the Act, each contractor
                      must be required to compute the wages of every mechanic
                      and laborer on the basis of a standard work week of 40
                      hours. Work in excess of the standard work week is
                      permissible provided that the worker is compensated at a
                      rate of not less than one and a half times the basic rate
                      of pay for all hours worked in excess of 40 hours in the
                      work week. The requirements of 40 U.S.C 3704 are
                      applicable to construction work and provide that no
                      laborer or mechanic must be required to work in
                      surroundings or under working conditions which are
                      unsanitary, hazardous or dangerous. These requirements do
                      not apply to the purchase of supplies or materials or
                      articles ordinarily available on the open market, or
                      contracts for transportation or transmission of
                      intelligence.&nbsp;</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      margin-top: 0pt;
                      margin-bottom: 0pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Rights to Inventions Made Under a Contract or Agreement.
                      If the Federal award meets the definition of
                      &ldquo;funding agreement&rdquo; under 37 CFR 401.2(a) and
                      the recipient or subrecipient wishes to enter into a
                      contract with small business firm or nonprofit
                      organization regarding the substitution of parties,
                      assignment or performance of experimental, developmental,
                      or research work under that &ldquo;funding
                      agreement,&rdquo; the recipient or subrecipient must
                      comply with the requirements of 37 CFR Part 401,
                      &ldquo;Rights to Inventions Made by Nonprofit
                      Organizations and Small Business Firms Under Government
                      Grants, Contracts and Cooperative Agreements,&rdquo; and
                      any implementing regulations issued by the awarding
                      agency.</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      margin-top: 0pt;
                      margin-bottom: 10pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Clean Air Act (42 U.S.C. 7401-7671q.) and the Federal
                      Water Pollution Control Act (33 U.S.C. 1251-1387), as
                      amended- Contract and subgrants of amounts in excess of
                      $150,000 must contain a provision that requires the
                      non-Federal award to agree to comply with all applicable
                      standards, orders or regulations issued pursuant to the
                      Clean Air Act (42 U.S.C &nbsp;7401-7671q) and the Federal
                      Water Pollution Control Act as amended (33 U.S.C
                      1251-1387). Violations must be reported to the Federal
                      awarding agency and the Regional Office of the
                      Environmental Protection Agency (EPA).</span
                    >
                  </p>
                </li>
              </ol>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXII - Terrorist Financing E.O. 13224</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with U.S. Executive Order 13224
                  and U.S. law that prohibit transactions with, and the
                  provisions of resources and support to, individuals and
                  organizations associated with terrorism. It is the legal
                  responsibility of recipients to ensure compliance with the
                  E.O. and laws.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXIII - Title IX of the Education Amendments of 1972
                  (Equal Opportunity in Education Act)</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with the requirements of Title
                  IX of the Education Amendments of 1972 (20 U.S.C. &sect; 1681
                  et seq.), which provides that no person in the United States
                  will, on the basis of sex, be excluded from participation in,
                  be denied the benefits of, or be subjected to discrimination
                  under any educational program or activity receiving Federal
                  financial assistance. Implementing regulations are codified at
                  6 C.F.R. Part 17 and 44 C.F.R. Part 19</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXIV - Trafficking Victims Protection Act of
                  2000</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with the requirements of the
                  government-wide award term which implements Section 106(g) of
                  the Trafficking Victims Protection Act (TVPA) of 2000, as
                  amended (22 U.S.C. &sect; 7104). This is implemented in
                  accordance with OMB Interim Final Guidance, Federal Register,
                  Volume 72, No. 218, November 13, 2007. Full text of the award
                  term is located at 2 CFR &sect; 175.15.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXV - Rehabilitation Act of 1973</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with the requirements of
                  Section 504 of the Rehabilitation Act of 1973, 29 U.S.C.
                  &sect; 794, as amended, which provides that no otherwise
                  qualified handicapped individual in the United States will,
                  solely by reason of the handicap, be excluded from
                  participation in, be denied the benefits of, or be subjected
                  to discrimination under any program or activity receiving
                  Federal financial assistance. These requirements pertain to
                  the provision of benefits or services as well as to
                  employment.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXVI - USA Patriot Act of 2001</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with requirements of the
                  Uniting and Strengthening America by Providing Appropriate
                  Tools Required to Intercept and Obstruct Terrorism Act (USA
                  PATRIOT Act), which amends 18 U.S.C. &sect;&sect;
                  175&ndash;175c.&nbsp;</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXVII - Whistleblower Protection Act</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must comply with the statutory requirements
                  for whistleblower protections (if applicable) at 10 U.S.C
                  &sect; 2409, 41U.S.C. 4712, and 10 U.S.C. &sect; 2324, 41
                  U.S.C. &sect;&sect; 4304 and 4310.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXVIII - Greene County Commission Specific
                  Acknowledgements and Assurances</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >All subrecipients must acknowledge and agree to comply with
                  applicable provisions governing Greene County Commission and
                  Greene County Auditor access to records, accounts, documents,
                  information, facilities, and staff.</span
                >
              </p>
              <ol
                style="
                  margin-top: 0;
                  margin-bottom: 0;
                  padding-inline-start: 48px;
                "
              >
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      text-align: justify;
                      margin-top: 0pt;
                      margin-bottom: 0pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Calibri, sans-serif;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Subrecipients must cooperate with any compliance review
                      or complaint investigation conducted by Greene
                      County.</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      text-align: justify;
                      margin-top: 0pt;
                      margin-bottom: 0pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Calibri, sans-serif;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Subrecipients must give Greene County Commission access
                      to and the right to examine and copy records, accounts,
                      and other documents and sources of information related to
                      the award and permit access to facilities, personnel, and
                      other individuals and information as may be necessary or
                      required by Greene County and other applicable laws or
                      program guidance.&nbsp;</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      text-align: justify;
                      margin-top: 0pt;
                      margin-bottom: 0pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Calibri, sans-serif;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Subrecipients must submit timely, complete, and accurate
                      reports to the appropriate Greene County officials and
                      provide appropriate backup documentation to support the
                      reports. Future awards and fund drawdowns may be withheld
                      if these reports are not complete.</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      text-align: justify;
                      margin-top: 0pt;
                      margin-bottom: 0pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Calibri, sans-serif;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >If, during the past three years, the recipient has been
                      accused of discrimination on the grounds of race, color,
                      national origin (including limited English proficiency),
                      sex, age, disability, religion, or familial status, the
                      recipient must provide a list of all such proceedings,
                      pending or completed, including outcome and copies of
                      settlement agreements to the Greene County
                      Commission.&nbsp;</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.3800000000000001;
                      text-align: justify;
                      margin-top: 0pt;
                      margin-bottom: 0pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Calibri, sans-serif;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >In the event any court or administrative agency makes a
                      finding of discrimination on grounds of race, color,
                      national origin (including limited English proficiency),
                      sex, age, disability, religion, or familial status against
                      the recipient, or the recipient settles a case or matter
                      alleging such discrimination, recipients must forward a
                      copy of the complaint and findings to the Greene County
                      Commission. The United States has the right to seek
                      judicial enforcement of these obligations.&nbsp;</span
                    >
                  </p>
                </li>
              </ol>
              <br />
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXIX - Disposition of Equipment Acquired Under the
                  Federal Award</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >When original or replacement equipment acquired under this
                  award by the recipient or its sub-recipients is no longer
                  needed for the original project or program or for other
                  activities currently or previously supported by ARPA funding
                  such assets may be disposed of following policies of
                  sub-sub-recipient. If such assets are disposed of prior to
                  December 31, 2024, the proceeds would be subject to the
                  restrictions on the eligible use of payments from the Fund
                  provided by section 601(d) of the Social Security Act.</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXX - Prior Approval for Modification of Approved
                  Budget</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.3800000000000001;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 10pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Before making any change to the Greene County approved budget
                  for this award, you must request prior written approval from
                  Greene County Commission by requesting a Subaward
                  Adjustment.&nbsp;</span
                >
              </p>
              <p
                dir="ltr"
                style="
                  line-height: 1.2;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXXI &ndash; Nondiscrimination in Matters Pertaining
                  to Faith-Based Organizations</span
                >
              </p>
              <br />
              <p
                dir="ltr"
                style="
                  line-height: 1.2;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Subrecipients must comply with the equal treatment policies
                  and requirements contained in 6 C.F.R. Part 19 and other
                  applicable statute, regulations, and guidance governing the
                  participations of faith-based organizations.&nbsp;</span
                >
              </p>
              <br />
              <p
                dir="ltr"
                style="
                  line-height: 1.2;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXXII &ndash; Acceptance of Post Award Changes</span
                >
              </p>
              <br />
              <p
                dir="ltr"
                style="
                  line-height: 1.2;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >In the event Greene County Commission determines that changes
                  are necessary to the award document after an award has been
                  made, including changes to period of performance or terms and
                  conditions, recipients will be notified of the changes in
                  writing. Once notification has been made, any subsequent
                  request for funds will indicate recipient acceptance of the
                  changes to the award.&nbsp;</span
                >
              </p>
              <br /><br /><br /><br /><br /><br /><br /><br /><br />
              <p
                dir="ltr"
                style="
                  line-height: 1.2;
                  text-align: justify;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: Calibri, sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 700;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article XXXIII &ndash; Other Specific Conditions</span
                >
              </p>
              <br />
              <ol
                style="
                  margin-top: 0;
                  margin-bottom: 0;
                  padding-inline-start: 48px;
                "
              >
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.2;
                      margin-top: 0pt;
                      margin-bottom: 0pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Applicable law &ndash; This agreement shall be construed
                      according to the laws of the State of Missouri.</span
                    >
                  </p>
                </li>
              </ol>
              <br />
              <ol
                start="2"
                style="
                  margin-top: 0;
                  margin-bottom: 0;
                  padding-inline-start: 48px;
                "
              >
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.2;
                      margin-top: 0pt;
                      margin-bottom: 6pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Greene County will not be liable to any subcontractor or
                      vendor for any expenses or liabilities incurred under the
                      sub-award. &nbsp;The sub-recipient shall be solely
                      responsible for the services provided in connection with
                      this Agreement and solely liable to any subcontractor or
                      vendor for all expenses and liabilities incurred under
                      this sub-award. &nbsp;The sub-recipient shall follow all
                      procurement requirements applicable under both Federal and
                      Missouri law, including but not limited to compliance with
                      sections 285.525 to 285.550, RSMo.</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.2;
                      margin-top: 0pt;
                      margin-bottom: 6pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Indemnification &ndash; The sub-recipient shall be
                      responsible for the acts, omissions to acts or negligence
                      of the sub-recipient, its agents, employees and assigns.
                      &nbsp;To the extent allowed by law, and subject to any
                      applicable sovereign immunity, the sub-recipient shall
                      hold harmless and indemnify Greene County including its
                      agents, employees and assigns, from every injury, damage,
                      expense, liability or payment, including legal fees,
                      arising out of any activities conducted by the
                      sub-recipient in connection with or in any way relating to
                      this Agreement.</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.2;
                      margin-top: 0pt;
                      margin-bottom: 6pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Sovereign Immunity &ndash; Greene County its agencies and
                      its subdivisions do not waive any defense of sovereign or
                      official immunity upon entering into this Agreement.</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.2;
                      margin-top: 0pt;
                      margin-bottom: 6pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >The sub-recipient will be responsible to meet the funding
                      requirements set out by the Greene County Commission.
                      &nbsp;Sub-recipient agrees to spend ARPA funding as
                      closely as possible to the documentation submitted with
                      the application to the Greene County Commission; deviation
                      from the awarded plan may result in non-payment of
                      requests from ARPA funding.</span
                    >
                  </p>
                </li>
                <li
                  aria-level="1"
                  dir="ltr"
                  style="
                    list-style-type: decimal;
                    font-size: 10pt;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                  "
                >
                  <p
                    dir="ltr"
                    style="
                      line-height: 1.2;
                      margin-top: 0pt;
                      margin-bottom: 6pt;
                    "
                  >
                    <span
                      style="
                        font-size: 10pt;
                        font-family: Arial;
                        color: #000000;
                        background-color: transparent;
                        font-weight: 400;
                        font-style: normal;
                        font-variant: normal;
                        text-decoration: none;
                        vertical-align: baseline;
                        white-space: pre;
                        white-space: pre-wrap;
                      "
                      >Funds awarded must adhere to official federal guidance
                      issued or to be issued on what constitutes a necessary
                      expenditure. &nbsp;Any funds awarded in this agreement
                      cannot be used as a revenue replacement for lower than
                      expected tax or other revenue collections. &nbsp;This
                      award is not for Research and Development and there is no
                      indirect cost rate.</span
                    >
                  </p>
                </li>
              </ol>
              <br /><br /><br />
            </td>
          </tr>
          <tr style="height: 26.3pt">
            <td
              style="
                border-left: solid #000000 0.5pt;
                border-right: solid #000000 0.5pt;
                border-bottom: solid #000000 0.5pt;
                border-top: solid #000000 0.5pt;
                vertical-align: top;
                padding: 0pt 5.4pt 0pt 5.4pt;
                overflow: hidden;
                overflow-wrap: break-word;
              "
            >
              <br />
            </td>
          </tr>
          <tr style="height: 26.3pt">
            <td
              style="
                border-left: solid #000000 0.5pt;
                border-right: solid #000000 0.5pt;
                border-bottom: solid #000000 0.5pt;
                border-top: solid #000000 0.5pt;
                vertical-align: top;
                padding: 0pt 5.4pt 0pt 5.4pt;
                overflow: hidden;
                overflow-wrap: break-word;
              "
            >
              <br />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p
      dir="ltr"
      style="
        line-height: 1.2;
        text-align: justify;
        margin-top: 0pt;
        margin-bottom: 0pt;
      "
    >
      <span
        style="
          font-size: 10pt;
          font-family: Arial;
          color: #000000;
          background-color: transparent;
          font-weight: 400;
          font-style: normal;
          font-variant: normal;
          text-decoration: none;
          vertical-align: baseline;
          white-space: pre;
          white-space: pre-wrap;
        "
        ><span class="Apple-tab-span" style="white-space: pre"
          >&nbsp; &nbsp;&nbsp;</span
        ></span
      >
    </p>
    <p><br /></p>
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend();
</script>
